import React, { useState, useEffect } from "react";
import fellowshipIcon from "./assets/fellowshipIcon.png";
import { auth } from "./firebase";
import Login from "./components/Login";
import AddPrayer from "./components/AddPrayer";
import PrayerCards from "./components/PrayerCards";
import UserProfile from "./components/UserProfile";

function App() {
  const [user, setUser] = useState(null);
  // authChecked becomes true after the first onAuthStateChanged callback runs
  const [authChecked, setAuthChecked] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Set favicon to fellowshipIcon
  useEffect(() => {
    const linkId = "dynamic-favicon";
    let link = document.querySelector(`link[rel="icon"]#${linkId}`) || document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.id = linkId;
      document.head.appendChild(link);
    }
    link.href = fellowshipIcon;
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => {
      setUser(u);
      setAuthChecked(true);
    });
    return unsubscribe;
  }, []);

  // While we don't yet know the auth state, show a loading indicator to
  // prevent briefly rendering the Login screen before the real state is known.
  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loader mb-4" aria-hidden="true" />
          <div className="text-gray-600">Loading…</div>
        </div>
      </div>
    );
  }

  // If auth was checked and there's no user, show Login.
  if (!user) {
    // pass a wrapped onLogin so callers (Login component) can set the user and
    // mark auth as checked in case they call onLogin directly after signing in.
    return (
      <Login
        onLogin={(u) => {
          setUser(u);
          setAuthChecked(true);
        }}
      />
    );
  }

  const handlePrayerAdded = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      <div>
        <UserProfile user={user} />
      </div>
      <PrayerCards user={user} refreshTrigger={refreshTrigger} />
      <AddPrayer onPrayerAdded={handlePrayerAdded} />
    </div>
  );
}

export default App;

